import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from 'svnxii-ng-shared/services';

export const SKIP_MUTATION_LOADING = new HttpContextToken<boolean>(() => false);

export const mutationLoadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  const isMutation =
    req.method === 'POST' ||
    req.method === 'PUT' ||
    req.method === 'PATCH' ||
    req.method === 'DELETE';
  const isTokenRefresh = req.url.split(/[?#]/, 1)[0].endsWith('/api/v1/iam/auth/refresh');

  if (!isMutation || isTokenRefresh || req.context.get(SKIP_MUTATION_LOADING)) {
    return next(req);
  }

  loadingService.show('mutation');

  return next(req).pipe(
    finalize(() => {
      loadingService.hide('mutation');
    }),
  );
};
